// JsFromRoutes CacheKey b4856e73e410b2a656889653e4f1596c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  impersonate: /* #__PURE__ */ definePathHelper('post', '/admin/users/:id/impersonate'),
  resetPasswordLink: /* #__PURE__ */ definePathHelper('get', '/admin/users/:id/reset_password_link'),
  sendMagicLink: /* #__PURE__ */ definePathHelper('post', '/admin/users/:id/send_magic_link'),
  stopImpersonating: /* #__PURE__ */ definePathHelper('post', '/admin/users/stop_impersonating'),
  addThatchBroker: /* #__PURE__ */ definePathHelper('post', '/admin/users/:id/add_thatch_broker'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/users'),
  edit: /* #__PURE__ */ definePathHelper('get', '/admin/users/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/users/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/users/:id'),
}
